import apiConversation from 'api/conversation'
import { getActiveUserFromState } from '../actionsHelpers'
import { updateUser } from './user'

const categoriesApi = apiConversation.categories

const getCategories = () => (dispatch, getState) => {
  const operatorSession = getState().user

  return new Promise((resolve, reject) => {
    const { brands, delegations } = operatorSession.brands.reduce((preV, next) => {
      if (next.id) preV.brands.push(next.id)
      if (next.delegations) preV.delegations.push(next.delegations)

      return preV
    }, { brands: [], delegations: [] })

    categoriesApi.getCategories({
      brands: brands.join(','),
      delegations: delegations.join(','),
      withoutBrands: true
    }).then(({ data, status }) => {
      if (status === 200) {
        return resolve(data)
      } else {
        return reject(data)
      }
    })
  })
}

const updateConversationCategory = (categoryId) => (dispatch, getState) => {
  const user = getActiveUserFromState(getState)
  categoriesApi
    .updateConversationCategory({ userId: user.id, categoryId })
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(updateUser(data))
      }
    })
    .catch(console.error)
}

export default {
  getCategories,
  updateConversationCategory,
}